export const addPeriodToString = (string: string) => {
  if (!string) return string;

  if (string[string.length - 1] === '.') return string;

  return `${string}.`;
};

export default addPeriodToString;
